export default __webpack_public_path__ + "static/media/iconPoint.5a62cb97.svg";